/* PLAKTON · pk-product.js — ficha de producto: colores y versiones del mismo modelo */
(function () {
  'use strict';

  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[\u00ae\u2122]/g, '').trim(); }
  function cap(s) { return s.replace(/(^|\s)\S/g, function (m) { return m.toUpperCase(); }); }

  function load(box) {
    var model = box.getAttribute('data-model');
    var key = 'pkModel:' + box.getAttribute('data-locale') + ':' + norm(model);
    try { var c = sessionStorage.getItem(key); if (c) return Promise.resolve(JSON.parse(c)); } catch (e) {}
    var base = box.getAttribute('data-search') + '?view=pk_model&type=product&options%5Bfields%5D=title&options%5Bprefix%5D=last&q=' + encodeURIComponent(model);
    var all = [];
    function page(n) {
      return fetch(base + '&page=' + n, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (d) {
          all = all.concat(d.items || []);
          if (d.pages > n && n < 6) return page(n + 1);
          return all;
        });
    }
    return page(1).then(function (items) {
      try { sessionStorage.setItem(key, JSON.stringify(items)); } catch (e) {}
      return items;
    });
  }

  function init(box) {
    if (box.hasAttribute('data-ready')) return;
    box.setAttribute('data-ready', '1');
    var model = norm(box.getAttribute('data-model'));
    var handle = box.getAttribute('data-handle');
    var finishes = (box.getAttribute('data-finishes') || '').split(',').map(norm).filter(Boolean);
    var list = box.querySelector('[data-pk-sib-list]');
    var chips = box.querySelector('[data-pk-sib-chips]');
    var more = box.querySelector('[data-pk-sib-more]');
    var count = box.querySelector('[data-pk-sib-count]');
    var T = {
      all: box.getAttribute('data-t-all'), more: box.getAttribute('data-t-more'),
      less: box.getAttribute('data-t-less'), out: box.getAttribute('data-t-out'), cur: box.getAttribute('data-t-current')
    };

    load(box).then(function (items) {
      var seen = {};
      var sibs = items.filter(function (p) {
        if (!p || !p.h || seen[p.h]) return false;
        seen[p.h] = 1;
        var first = norm(p.t).split(/\s+/)[0];
        return first === model && p.h.indexOf('copy-of') !== 0;
      });
      if (sibs.length < 2) { box.remove(); return; }
      sibs.forEach(function (p) {
        var t = norm(p.t);
        p.f = '';
        for (var i = 0; i < finishes.length; i++) {
          if ((' ' + t + ' ').indexOf(' ' + finishes[i] + ' ') > -1) { p.f = finishes[i]; break; }
        }
        p.cur = p.h === handle;
        p.u = (p.u || '').split('?')[0];
        var words = p.t.replace(/[\u00ae\u2122]/g, '').trim().split(/\s+/); words.shift();
        p.n = words.join(' ');
      });
      /* El producto que estás viendo, primero */
      sibs.sort(function (a, b) { return (b.cur ? 1 : 0) - (a.cur ? 1 : 0) || (b.a ? 1 : 0) - (a.a ? 1 : 0); });
      var current = sibs.filter(function (p) { return p.cur; })[0];

      /* Filtro por acabado: solo si hay al menos dos acabados distintos */
      var groups = {};
      sibs.forEach(function (p) { if (p.f) groups[p.f] = (groups[p.f] || 0) + 1; });
      var keys = Object.keys(groups).sort(function (a, b) { return groups[b] - groups[a]; });
      var active = (current && current.f && keys.length > 1) ? current.f : '';
      var expanded = false;
      var LIMIT = 5; /* a partir de aquí se ofrece «Ver todos» (cuadrícula) */

      function label(p) {
        var n = p.n;
        if (active) n = n.replace(new RegExp('\\s*' + active.replace(/\s+/g, '\\s+') + '\\b', 'i'), '');
        return n.trim() || p.n;
      }
      function renderChips() {
        if (keys.length < 2) { chips.hidden = true; return; }
        var h = '<button type="button" role="tab" data-f="" aria-selected="' + (active === '') + '"' + (active === '' ? ' class="is-on"' : '') + '>' + esc(T.all) + ' <span>' + sibs.length + '</span></button>';
        keys.forEach(function (k) {
          h += '<button type="button" role="tab" data-f="' + esc(k) + '" aria-selected="' + (active === k) + '"' + (active === k ? ' class="is-on"' : '') + '>' + esc(cap(k)) + ' <span>' + groups[k] + '</span></button>';
        });
        chips.innerHTML = h;
        chips.hidden = false;
      }
      function renderList() {
        var shown = sibs.filter(function (p) { return !active || p.f === active || p.cur; });
        var visible = shown;
        var h = '';
        visible.forEach(function (p) {
          var cls = 'pk-sib__item' + (p.cur ? ' is-current' : '') + (p.a ? '' : ' is-out');
          var inner = '<span class="pk-sib__img">' + (p.i ? '<img src="' + esc(p.i) + '" alt="" width="130" height="130" loading="lazy">' : '') + (p.a ? '' : '<em>' + esc(T.out) + '</em>') + '</span>' +
            '<span class="pk-sib__name">' + esc(label(p)) + '</span>';
          h += '<li>' + (p.cur
            ? '<span class="' + cls + '" aria-current="true" title="' + esc(T.cur + ': ' + p.t) + '">' + inner + '</span>'
            : '<a class="' + cls + '" href="' + esc(p.u) + '" title="' + esc(p.t) + '">' + inner + '</a>') + '</li>';
        });
        list.innerHTML = h;
        list.classList.remove('is-loading');
        list.removeAttribute('aria-busy');
        list.classList.toggle('is-all', expanded);
        if (!expanded) list.scrollLeft = 0;
        count.textContent = shown.length;
        count.hidden = shown.length > LIMIT;
        if (shown.length > LIMIT) {
          more.hidden = false;
          more.textContent = expanded ? T.less : T.more.replace('__N__', shown.length);
          more.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        } else {
          more.hidden = true;
        }
      }
      /* Flechas y degradado cuando la fila no cabe */
      var prev = box.querySelector('[data-pk-sib-prev]'), next = box.querySelector('[data-pk-sib-next]');
      var rail = box.querySelector('.pk-sib__rail');
      function edges() {
        var over = !expanded && list.scrollWidth > list.clientWidth + 4;
        var atStart = list.scrollLeft <= 4, atEnd = list.scrollLeft + list.clientWidth >= list.scrollWidth - 4;
        if (prev) prev.hidden = !over || atStart;
        if (next) next.hidden = !over || atEnd;
        rail.classList.toggle('has-more-r', over && !atEnd);
        rail.classList.toggle('has-more-l', over && !atStart);
      }
      function step(dir) { list.scrollBy({ left: dir * Math.max(140, list.clientWidth * 0.8), behavior: 'smooth' }); }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      list.addEventListener('scroll', edges, { passive: true });
      window.addEventListener('resize', edges);
      chips.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-f]'); if (!b) return;
        active = b.getAttribute('data-f'); expanded = false;
        renderChips(); renderList(); edges();
      });
      more.addEventListener('click', function () { expanded = !expanded; renderList(); edges(); });
      renderChips(); renderList(); edges();
      setTimeout(edges, 400);
    }).catch(function () { box.remove(); });
  }


  /* ---------- Guía de tallas propia ---------- */
  function sizeGuide() {
    var dlg = document.getElementById('PkSizeGuide');
    if (!dlg || dlg.hasAttribute('data-ready')) return;
    dlg.setAttribute('data-ready', '1');
    if (dlg.parentNode !== document.body) document.body.appendChild(dlg);
    function tab(id) {
      dlg.querySelectorAll('[data-pk-sg-tab]').forEach(function (b) { var on = b.getAttribute('data-pk-sg-tab') === id; b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); });
      dlg.querySelectorAll('[data-pk-sg-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-pk-sg-panel') !== id; });
    }
    function selectedSize() {
      var r = document.querySelectorAll('.productView-details .product-form__radio:checked');
      for (var i = 0; i < r.length; i++) { var n = parseFloat(r[i].value); if (n >= 15 && n <= 50) return String(r[i].value).trim(); }
      return '';
    }
    function open() {
      var sz = selectedSize();
      dlg.querySelectorAll('td.is-mine').forEach(function (td) { td.classList.remove('is-mine'); });
      if (sz) dlg.querySelectorAll('td[data-eu="' + sz + '"]').forEach(function (td) { td.classList.add('is-mine'); });
      tab(sz && parseFloat(sz) < 35 ? 'ki' : 'ad');
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      document.documentElement.classList.add('pk-sg-open');
      var mine = dlg.querySelector('[data-pk-sg-panel]:not([hidden]) td.is-mine');
      if (mine) { var sc = mine.closest('.pk-sg__scroll'); sc.scrollLeft = Math.max(0, mine.offsetLeft - sc.clientWidth / 2 + mine.offsetWidth / 2); }
    }
    function close() { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); }
    dlg.addEventListener('close', function () { document.documentElement.classList.remove('pk-sg-open'); });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('[data-pk-sg-close]')) { close(); return; }
      var t = e.target.closest('[data-pk-sg-tab]'); if (t) tab(t.getAttribute('data-pk-sg-tab'));
    });
    /* Sustituye a la ventana de la imagen de tallas del tema */
    document.addEventListener('click', function (e) {
      var trg = e.target.closest('[data-open-size-chart-popup], [data-pk-sg-open]');
      if (!trg || !(trg.closest('.productView-details') || trg.hasAttribute('data-pk-sg-open'))) return;
      e.preventDefault(); e.stopPropagation();
      open();
    }, true);
  }

  /* ---------- Galería en cuadrícula: visor a pantalla completa ---------- */
  function gallery() {
    var gal = document.querySelector('[data-pk-gal]');
    if (!gal || gal.hasAttribute('data-ready')) return;
    gal.setAttribute('data-ready', '1');
    var items = Array.prototype.slice.call(gal.querySelectorAll('[data-pk-gal-i]'));
    var srcs = items.map(function (b) { return b.getAttribute('data-full'); });
    var ico = function (d) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="' + d + '"/></svg>'; };
    var lb = document.createElement('dialog');
    lb.className = 'pk-lb';
    lb.innerHTML = '<img alt="">' +
      '<button type="button" class="pk-lb__close" aria-label="Close">' + ico('M6 6l12 12M18 6 6 18') + '</button>' +
      '<button type="button" class="pk-lb__prev" aria-label="Previous">' + ico('M15 6l-6 6 6 6') + '</button>' +
      '<button type="button" class="pk-lb__next" aria-label="Next">' + ico('M9 6l6 6-6 6') + '</button>' +
      '<span class="pk-lb__count"></span>';
    document.body.appendChild(lb);
    var img = lb.querySelector('img'), count = lb.querySelector('.pk-lb__count'), cur = 0;
    function show(i) {
      cur = (i + srcs.length) % srcs.length;
      img.src = srcs[cur];
      count.textContent = (cur + 1) + ' / ' + srcs.length;
    }
    function close() { lb.close(); }
    lb.addEventListener('close', function () { document.documentElement.classList.remove('pk-lb-open'); });
    lb.addEventListener('click', function (e) {
      if (e.target.closest('.pk-lb__close') || e.target === lb) return close();
      if (e.target.closest('.pk-lb__prev')) return show(cur - 1);
      if (e.target.closest('.pk-lb__next')) return show(cur + 1);
      if (e.target === img) return show(cur + 1);
    });
    lb.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') show(cur - 1);
      if (e.key === 'ArrowRight') show(cur + 1);
    });
    var curEl = gal.parentNode.querySelector('[data-pk-gal-cur]');
    if (curEl) gal.addEventListener('scroll', function () {
      var i = Math.round(gal.scrollLeft / Math.max(1, gal.clientWidth));
      curEl.textContent = Math.min(items.length, i + 1);
    }, { passive: true });
    gal.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pk-gal-i]'); if (!b) return;
      show(Number(b.getAttribute('data-pk-gal-i')));
      lb.showModal();
      document.documentElement.classList.add('pk-lb-open');
    });
  }

  /* ---------- «Guía de tallas» a la altura del título de las tallas ---------- */
  function moveSizeLink() {
    var link = document.querySelector('.productView-details .productView-sizeChart a[data-open-size-chart-popup]');
    if (!link) return;
    var sets = document.querySelectorAll('.productView-details fieldset.product-form__input');
    var target = null;
    for (var i = 0; i < sets.length; i++) {
      var r = sets[i].querySelector('.product-form__radio');
      if (r && !isNaN(parseFloat(r.value))) { target = sets[i]; break; }
    }
    if (!target) return;
    var legend = target.querySelector('legend');
    if (!legend || legend.querySelector('[data-open-size-chart-popup]')) return;
    link.classList.add('pk-sizelink');
    legend.classList.add('pk-has-sizelink');
    legend.appendChild(link);
    var perks = document.querySelector('.productView-details .productView-sizeChart');
    if (perks && !perks.children.length) {
      var item = perks.closest('.productView-moreItem');
      if (item && !item.querySelector('a, button')) item.style.display = 'none';
    }
  }

  /* ---------- Barra de compra flotante ---------- */
  function stickyBuy() {
    var bar = document.querySelector('[data-pk-sb]');
    if (!bar || bar.hasAttribute('data-ready')) return;
    /* Ojo: antes del formulario de compra hay otro de «pagos a plazos» con la misma acción; vamos al del botón */
    var add = document.querySelector('.productView-details product-form [data-btn-addToCart], .productView-details product-form [name="add"], .productView-details [data-btn-addToCart]');
    var form = add && add.closest('form');
    if (!add || !form) return;
    bar.setAttribute('data-ready', '1');
    document.body.appendChild(bar);
    var btn = bar.querySelector('[data-pk-sb-btn]'), sub = bar.querySelector('[data-pk-sb-sub]');
    var label = btn.textContent;
    var V = {}, names = [], multi = [];
    try { V = JSON.parse(bar.querySelector('[data-pk-sb-variants]').textContent); names = JSON.parse(bar.querySelector('[data-pk-sb-opts]').textContent); multi = JSON.parse(bar.querySelector('[data-pk-sb-multi]').textContent); } catch (e) {}
    /* Selector de talla dentro de la barra: refleja las tallas de la ficha y las cambia allí */
    var sizeWrap = bar.querySelector('[data-pk-sb-sizewrap]'), sizeSel = bar.querySelector('[data-pk-sb-size]');
    var sizeSet = null;
    document.querySelectorAll('.productView-details fieldset.product-form__input').forEach(function (fs) {
      var r = fs.querySelector('.product-form__radio');
      if (!sizeSet && r && !isNaN(parseFloat(r.value)) && fs.querySelectorAll('.product-form__radio').length > 1) sizeSet = fs;
    });
    function buildSizes() {
      if (!sizeSet) return;
      var out = bar.getAttribute('data-t-out') || '';
      var lg0 = sizeSet.querySelector('legend'), nm0 = lg0 ? lg0.textContent.split(':')[0].trim() : '';
      nm0 = nm0 ? nm0.charAt(0).toUpperCase() + nm0.slice(1).toLowerCase() : '';
      var h = '';
      sizeSet.querySelectorAll('.product-form__radio').forEach(function (r) {
        var lab = sizeSet.querySelector('label[for="' + r.id + '"]');
        var sold = (lab && /soldout|unavailable/.test(lab.className)) || r.disabled;
        h += '<option value="' + r.value.replace(/"/g, '&quot;') + '"' + (r.checked ? ' selected' : '') + '>' + (nm0 ? nm0 + ' ' : '') + r.value + (sold ? ' · ' + out : '') + '</option>';
      });
      sizeSel.innerHTML = h;
      var leg = sizeSet.querySelector('legend');
      var nm = leg ? leg.textContent.split(':')[0].trim() : '';
      nm = nm ? nm.charAt(0).toUpperCase() + nm.slice(1).toLowerCase() : '';
      bar.querySelector('[data-pk-sb-sizename]').textContent = nm;
      sizeWrap.hidden = false;
      bar.classList.add('has-size');
    }
    buildSizes();
    if (sizeSel) sizeSel.addEventListener('change', function () {
      var r = sizeSet && sizeSet.querySelector('.product-form__radio[value="' + sizeSel.value.replace(/"/g, '\\"') + '"]');
      if (r) { r.click(); setTimeout(function () { buildSizes(); sync(); }, 150); setTimeout(sync, 600); }
    });
    function sync() {
      var idEl = form.querySelector('[name="id"]');
      var v = idEl && V[idEl.value];
      var parts = [];
      if (v) {
        if (!sizeSet) v.o.forEach(function (val, i) { if (multi[i] > 1) parts.push(names[i] + ' ' + val); });
        parts.push(v.p);
      }
      sub.textContent = parts.join(' · ');
      if (sizeSet && sizeSel) { var c = sizeSet.querySelector('.product-form__radio:checked'); if (c && sizeSel.value !== c.value) sizeSel.value = c.value; }
      btn.disabled = !!add.disabled;
      btn.textContent = add.disabled ? add.textContent.trim() : label;
    }
    sync();
    new MutationObserver(sync).observe(add, { attributes: true, attributeFilter: ['disabled'], childList: true, characterData: true, subtree: true });
    form.addEventListener('change', function () { setTimeout(sync, 60); });
    document.addEventListener('change', function (e) { if (e.target.closest('.productView-details')) setTimeout(sync, 120); });
    btn.addEventListener('click', function () { add.click(); });
    bar.querySelector('[data-pk-sb-up]').addEventListener('click', function () {
      var t = document.querySelector('.productView-details .productView-moreItem-product-variant') || add;
      window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 140, behavior: 'smooth' });
    });
    var mobile = window.matchMedia('(max-width: 1024px)');
    function show(on) {
      bar.classList.toggle('is-on', on);
      document.documentElement.classList.toggle('pk-sb-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      btn.tabIndex = on ? 0 : -1;
      if (sizeSel) sizeSel.tabIndex = on ? 0 : -1;
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          /* Como en Lionzen: aparece al bajar y dejar atrás el botón principal */
          show(!e.isIntersecting && e.boundingClientRect.top < 0);
        });
      }, { threshold: 0 }).observe(add);
    }
  }

  function safe(fn) { try { fn(); } catch (e) { if (window.console) console.warn('[pk-product]', e); } }
  /* El párrafo «**…talla…» de la descripción sobra si ya se muestra el consejo de talla */
  function descTip() {
    if (!document.querySelector('.pk-fit, .pk-desc__tip')) return;
    var body = document.querySelector('.pk-desc__body');
    if (!body) return;
    Array.prototype.slice.call(body.children, 0, 3).forEach(function (el) {
      if (/^\s*\*\*/.test(el.textContent || '')) el.style.display = 'none';
    });
  }

  function run() {
    document.querySelectorAll('[data-pk-sib]').forEach(function (b) { safe(function () { init(b); }); });
    safe(sizeGuide); safe(gallery); safe(moveSizeLink); safe(stickyBuy); safe(descTip);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
